<template>
  <div class="container">
    <div class="header">
      <div class="logo"></div>
      <a
        class="submit"
        to="/contribution"
        style="cursor: pointer"
        @click="handleContributionClick"
        >SUBMIT</a
      >
    </div>

    <div class="clear"></div>
    <div class="center-text">Create Better Life</div>
    <div class="sub-title">
      <p>
        What would be our daily life if we lost the power of creation? Thanks to
        the God, Human beings has never stopped exploring the unknow. We create
        new things and better our life. Creation and innovation that originates
        from our daily life inadvertently changes the way we live and enhances
        the quality of our life. Creation is around the corner from anywhere.
      </p>
      <p>
        HopTip is dedicated to discovering, introducing and promoting the most
        innovative things in the world which makes our lives better.
      </p>
    </div>
    <div class="main">
      <div class="left-box"></div>
      <div class="right-box">
        <div>
          <p>
            A dreamer is one who can only find his way by moonlight, and his
            punishment is that he sees the dawn before the rest of the world.
          </p>
          <p>
            we believe that a small step forward can change slightly. However,
            clusters of spark will lighten the world definitely.
          </p>
        </div>
        <div class="qrcode">
          <div>
            <img src="@/assets/images/qr_baidu.png" alt />
            <br />百度手机助手
          </div>
          <div>
            <img src="@/assets/images/qr_google.png" alt />
            <br />Google Play
          </div>
          <div>
            <img src="@/assets/images/qr_ios.png" alt />
            <br />iOS
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      CopyRight@Hoptip &nbsp;&nbsp;&nbsp;
      <a href="http://www.beian.miit.gov.cn/" target="_blank"
        >京ICP备20027298号</a
      >
      &nbsp;&nbsp;&nbsp;info@hoptip.com
    </div>
    <!-- <div class="layer">
          <div class="eject"></div>
    </div>-->
    <masklayer :show="show" :modal="modal">
      <div class="vue-content">
        <div
          style="
            text-align: right;
            color: gray;
            font-size: 24px;
            margin-right: 20px;
            cursor: pointer;
          "
          @click="handleCloseClick"
        >
          x
        </div>
        <div
          id="qr"
          ref="qrcode"
          style="width: 176px; height: 176px; margin: 20px auto"
        ></div>
        <a style="color: black" @click="handleRefreshClick" v-show="showQr"
          >重新刷新二维码</a
        >
        <a style="color: black" @click="handleRefreshClick" v-show="!showQr"
          >打开 Hoptip App 扫码登录</a
        >
      </div>
    </masklayer>
    <!-- <vue-qr :logoSrc="imageUrl" text="111111" :size="500"></vue-qr> -->
  </div>
</template>

<script>
// import VueQr from "vue-qr";
import QRCode from "qrcodejs2";
import { getAuthCode, getToken } from "@/api";
//  import masklayer from 'vue-masklayer'
export default {
  name: "Home",
  // components: {
  //   masklayer:masklayer
  // },
  data() {
    return {
      show: false, //  是否显示弹层
      modal: false,
      height: 0,
      imageUrl: require("../assets/images/qr_google.png"),
      code: "",
      timer: null,
      showQr: false,
      num: 180,
      timer60: null,
    };
  },
  created() {
 
  },
  mounted() {
    let height = window.innerHeight;
    this.height = height;
    window.clearTimeout(this.timer);
  },
  methods: {
    timer60setInterval() {
      this.timer60 = setInterval(() => {
        if (this.num > 0) {
          this.num--;
        } else {
          this.showQr = true;
          this.num = 180;
          window.clearInterval(this.timer60);
        }
      }, 1000);
    },
    handleRefreshClick() {
      this.showQr = false;
      this.timer60setInterval();
      document.querySelector("#qr img").remove();
      window.clearTimeout(this.timer);
      this.requestGetAuthCode();
    },
    requestGetAuthCode() {
      this.timer60setInterval();
      getAuthCode().then((res) => {
        // //console.log(res);
        if (res.code == 200) {
          this.code = res.data;
          this.$nextTick(() => {
            this.qrcode();
          });
          this.requestGetToken();
        }
      });
    },
    requestGetToken() {
      window.clearTimeout(this.timer); // 此处的timer即 上文const的 timer
      this.timer = null;
      getToken({ authCode: this.code })
        .then((res) => {
          // //console.log(res);
          if (res.code == 200) {
                localStorage.setItem("token", res.data);
            this.$router.push('/list');
        
          }
        })
        .catch((err) => {
          // console.log(err);
          this.timer = setTimeout(() => {
            this.requestGetToken();
          }, 1000);
        });
    },
    handleContributionClick() {
      this.show = true;
      this.requestGetAuthCode();
    },
    qrcode() {
      let qrcode = new QRCode("qr", {
        width: 176, // 设置宽度，单位像素
        height: 176, // 设置高度，单位像素
        text: this.code, // 设置二维码内容或跳转地址
      });
    },
    handleCloseClick() {
      this.num = 180;
      window.clearInterval(this.timer60);
      this.show = false;
      window.clearTimeout(this.timer); // 此处的timer即 上文const的 timer
      this.timer = null;
    },
  },
};
</script>
   
<style>
.center-text {
  text-align: center;

  font-size: 32px;
  font-family: Arial;
  font-weight: bold;
  font-style: italic;
  color: #ffffff;
  line-height: 40px;
}
.sub-title {
  font-size: 22px;
  font-family: Arial;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  text-shadow: 0px 15px 76px rgba(0, 0, 0, 0.5);
  width: 1100px;
  text-align: left;
  margin: 0 auto;
}
.submit {
  display: inline-block;
  width: 108px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #ffffff;
}
.layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
.eject {
  min-height: 500px;
  width: 790px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -395px;
  margin-top: -250px;
}
.vue-content {
  width: 280px;
  height: 320px;
  background-color: white;
  text-align: center;
  position: absolute;
  right: 43px;
  top: 117px;
}
.clear {
  clear: both;
}
.container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-image: url(../assets/images/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  /* background-attachment:fixed; */
  padding-top: 1px;
  box-sizing: border-box;
  /* overflow: hidden; */
}
.header {
  /* width: 100%; */
  height: 73px;
  margin: 28px;
  margin-bottom: 0;
  position: relative;
}
.logo {
  width: 57px;
  height: 73px;
  background-image: url(../assets/images/logo.png);
  background-repeat: repeat;
  background-size: cover;
  /* margin: 28px; */
  float: left;
}
.header a {
  color: #36b2ff;
  text-decoration: none;
  font-weight: bold;
  position: absolute;
  bottom: 0px;
  right: 0;
  /* top: 50%;
  transform: translateY(-50%); */
}
.main {
  width: 1100px;
  margin: 0 auto;
  display: flex;
}
.left-box {
  width: 263px;
  height: 495px;
  background-image: url(../assets/images/m.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.right-box {
  width: 774px;
  font-size: 20px;
  font-family: Arial;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  text-shadow: 0px 11px 54px rgba(0, 0, 0, 0.5);
  margin-left: 49px;
}

.qrcode {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 153px;
}

.qrcode div {
  font-size: 17px;
  font-family: Arial;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
  opacity: 0.8;
}

.qrcode div img {
  width: 142px;
  height: 142px;
}

.qrcode div:nth-of-type(2) {
  margin-left: 43px;
}
.qrcode div:nth-of-type(3) {
  margin-left: 43px;
}
.footer {
  width: 100%;
  height: 40px;
  text-align: center;
  margin-top: 15%;
  font-size: 14px;
  font-family: Arial;
  color: rgba(255, 255, 255, 1);
  /* position: absolute;
  bottom: -7%; */
  /* position: fixed;
  bottom: 10px; */
}

.footer a {
  font-size: 14px;
  font-family: Arial;
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
}
.JQ-masklayer {
  position: absolute;
  right: 27px;
  top: 100px;
  /* width: 100%; */
  /* height: 100%; */
}
</style>
